<footer class="footer">
  <div class="container mx-auto px-6 w-full">
    <div class="gird grid-cols-12">
      <div class="col-span-12 footer-copyright text-center">
        <p class="mb-0">
          Copyright <span class="year-update">{{ getCurrentYear() }}</span> ©
          Capital Divisas
        </p>
      </div>
    </div>
  </div>
</footer>
